import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const postJoinExistingEmployeeToProject = async ({
  projectId,
  userId,
  employerBusinessId,
  recordDate,
}) => {
  const apiPath = `projects/${projectId}/join-existing-employee`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: { userId, employerBusinessId, recordDate },
  });

  const response = await axios(signedRequest);

  return response.data;
};
